// extracted by mini-css-extract-plugin
export default {"colorcovered":"#7e57c5","colorremaining":"#e5ceff","CoverageChartPercent":"CoverageChart_CoverageChartPercent__Xidfy","percent":"CoverageChart_percent__fmTm7"};